import type { LOCAL_STORAGE_KEYS } from '.';
import BaseStorageService from './base';

class OnceStorage extends BaseStorageService {
  set(key: LOCAL_STORAGE_KEYS, token: string) {
    this.setItem(key, token);
  }

  get(key: LOCAL_STORAGE_KEYS): string | undefined {
    return this.getItem(key);
  }

  clear(key: LOCAL_STORAGE_KEYS): void {
    this.removeItem(key);
  }
}

export default OnceStorage;
